/**
 * Fisher-Yates shuffle. Devuelve una copia barajada del array original
 * (no muta la entrada). `Math.random()` basta para barajar UI.
 */
export function shuffle<T>(arr: readonly T[]): T[] {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j] as T, copy[i] as T];
  }
  return copy;
}
